import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@Integrations/Connectors/commands-core'
import { isRef, ref, Ref } from 'vue'

export function useConfigureConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	updatedBy?: string | Ref<string> | (() => string), 
	providerType?: string | Ref<string> | (() => string), 
	config?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _updatedBy = isRef<string>(updatedBy) ? updatedBy : ref<string>((typeof updatedBy === 'function') ? updatedBy() : updatedBy)
	const _providerType = isRef<string>(providerType) ? providerType : ref<string>((typeof providerType === 'function') ? providerType() : providerType)
	const _config = isRef<string>(config) ? config : ref<string>((typeof config === 'function') ? config() : config)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		updatedBy: _updatedBy,
		providerType: _providerType,
		config: _config,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof updatedBy === 'function') { _updatedBy.value = updatedBy() }
			if (typeof providerType === 'function') { _providerType.value = providerType() }
			if (typeof config === 'function') { _config.value = config() }

			return new c.ConfigureConnectorCommandV1(_id.value, _organizationUnitId.value, _updatedBy.value, _providerType.value, _config.value)
		})
	}

	return {
		...result,
		authorizedConfigureConnectorCommandV1: result.authorized,
		configureConnectorCommandV1: result.command,
		completedConfigureConnectorCommandV1: result.completed,
		errorConfigureConnectorCommandV1: result.error,
		invokeConfigureConnectorCommandV1: result.invoke,
		invokingConfigureConnectorCommandV1: result.invoking,
		succeedConfigureConnectorCommandV1: result.succeed,
		validationErrorsConfigureConnectorCommandV1: result.validationErrors,
		onSucceedConfigureConnectorCommandV1: result.onSucceed,
	}
}

export function useCreateConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	createdBy?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	providerType?: string | Ref<string> | (() => string), 
	config?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _createdBy = isRef<string>(createdBy) ? createdBy : ref<string>((typeof createdBy === 'function') ? createdBy() : createdBy)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _providerType = isRef<string>(providerType) ? providerType : ref<string>((typeof providerType === 'function') ? providerType() : providerType)
	const _config = isRef<string>(config) ? config : ref<string>((typeof config === 'function') ? config() : config)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		createdBy: _createdBy,
		name: _name,
		providerType: _providerType,
		config: _config,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof createdBy === 'function') { _createdBy.value = createdBy() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof providerType === 'function') { _providerType.value = providerType() }
			if (typeof config === 'function') { _config.value = config() }

			return new c.CreateConnectorCommandV1(_id.value, _organizationUnitId.value, _createdBy.value, _name.value, _providerType.value, _config.value)
		})
	}

	return {
		...result,
		authorizedCreateConnectorCommandV1: result.authorized,
		createConnectorCommandV1: result.command,
		completedCreateConnectorCommandV1: result.completed,
		errorCreateConnectorCommandV1: result.error,
		invokeCreateConnectorCommandV1: result.invoke,
		invokingCreateConnectorCommandV1: result.invoking,
		succeedCreateConnectorCommandV1: result.succeed,
		validationErrorsCreateConnectorCommandV1: result.validationErrors,
		onSucceedCreateConnectorCommandV1: result.onSucceed,
	}
}

export function useDeleteConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	deletedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _deletedBy = isRef<string>(deletedBy) ? deletedBy : ref<string>((typeof deletedBy === 'function') ? deletedBy() : deletedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		deletedBy: _deletedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof deletedBy === 'function') { _deletedBy.value = deletedBy() }

			return new c.DeleteConnectorCommandV1(_id.value, _organizationUnitId.value, _deletedBy.value)
		})
	}

	return {
		...result,
		authorizedDeleteConnectorCommandV1: result.authorized,
		deleteConnectorCommandV1: result.command,
		completedDeleteConnectorCommandV1: result.completed,
		errorDeleteConnectorCommandV1: result.error,
		invokeDeleteConnectorCommandV1: result.invoke,
		invokingDeleteConnectorCommandV1: result.invoking,
		succeedDeleteConnectorCommandV1: result.succeed,
		validationErrorsDeleteConnectorCommandV1: result.validationErrors,
		onSucceedDeleteConnectorCommandV1: result.onSucceed,
	}
}

export function usePermanentDeleteConnectorCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.PermanentDeleteConnectorCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedPermanentDeleteConnectorCommandV1: result.authorized,
		permanentDeleteConnectorCommandV1: result.command,
		completedPermanentDeleteConnectorCommandV1: result.completed,
		errorPermanentDeleteConnectorCommandV1: result.error,
		invokePermanentDeleteConnectorCommandV1: result.invoke,
		invokingPermanentDeleteConnectorCommandV1: result.invoking,
		succeedPermanentDeleteConnectorCommandV1: result.succeed,
		validationErrorsPermanentDeleteConnectorCommandV1: result.validationErrors,
		onSucceedPermanentDeleteConnectorCommandV1: result.onSucceed,
	}
}

